var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{attrs:{"data-placeholder":_vm.placeholder,"multiple":_vm.multiple,"disabled":_vm.disabled,"required":_vm.required}},_vm._l((_vm.localOptions),function(option){return _c('option',{domProps:{"value":option[_vm.trackBy]}},[_vm._v(_vm._s(option[_vm.label]))])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d84cb24","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Global/Chosen.vue
// module id = 750
// module chunks = 0